import React, { useEffect, useState } from 'react'
import type { InputNumberProps } from 'antd'
import { InputNumber } from 'antd'
import { BasicSlider } from '../basic-slider/basic-slider'

type SliderInputProps = {
  suffix?: string
  value?: number
  disabled?: boolean
  decimals?: number
  onChange?: (value: number) => void
}

const SliderInput: React.FC<SliderInputProps> = ({ suffix = '', value, disabled = false, decimals = 1, onChange }) => {
  const [inputValue, setInputValue] = useState(value ?? 0)
  const step = decimals > 0 ? 1 / 10 ** decimals : 1

  useEffect(() => {
    setInputValue(value ?? 0)
  }, [value])

  const onSliderChange = (newValue: number) => {
    setInputValue(newValue)
    onChange?.(newValue)
  }

  const onInputChange: InputNumberProps['onChange'] = newValue => {
    const nextValue = (newValue as number) ?? 0
    setInputValue(nextValue)
    onChange?.(nextValue)
  }

  return (
    <div className={`slider-input ${disabled ? 'slider-input-disabled' : ''}`}>
      <BasicSlider
        className="slider-input-control"
        min={0}
        max={100}
        step={step}
        disabled={disabled}
        onChange={onSliderChange}
        value={typeof inputValue === 'number' ? inputValue : 0}
      />
      <InputNumber
        className="slider-input-number"
        min={0}
        max={100}
        step={step}
        precision={decimals}
        disabled={disabled}
        value={inputValue}
        onChange={onInputChange}
        suffix={suffix || undefined}
      />
    </div>
  )
}

export default SliderInput
